/* Waïloa – recherche prédictive + synonymes
   - suggestions dès 2 caractères (250 ms), requêtes annulées si l'on continue de taper
   - produits + suggestions de requêtes + collections + pages/articles
   - synonymes et fautes courantes : réglage « Synonymes » de la section Header (window.wlSearchSynonyms)
     « sweat » → sweat OR hoodie OR sweatshirt (recherche instantanée ET page de résultats)
   - aucun résultat : message + recherches populaires et collections mises en avant
   - historique : seulement les recherches validées */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var SYN = window.wlSearchSynonyms || {};

  function norm(s) {
    s = String(s || '').toLowerCase().trim().replace(/\s+/g, ' ');
    try { s = s.normalize('NFD').replace(/[̀-ͯ]/g, ''); } catch (e) {}
    return s;
  }
  var MAP = {};
  Object.keys(SYN).forEach(function (k) { MAP[norm(k)] = String(SYN[k]).split(',').map(function (x) { return x.trim(); }).filter(Boolean); });

  /* Renvoie la liste [terme, synonymes…] (sans doublons) ou [terme] */
  function variants(term) {
    var t = String(term || '').trim();
    var list = [t];
    var syn = MAP[norm(t)];
    if (syn) syn.forEach(function (x) { if (list.map(norm).indexOf(norm(x)) === -1) list.push(x); });
    return list;
  }
  function expanded(term) {
    if (/\sOR\s/.test(term)) return term;
    var v = variants(term);
    if (v.length < 2) return term;
    return v.map(function (x) { return /\s/.test(x) ? '"' + x.replace(/"/g, '') + '"' : x; }).join(' OR ');
  }
  function searchUrl(term) { return root + 'search?q=' + encodeURIComponent(expanded(term)) + '&options%5Bprefix%5D=last'; }
  window.wlSearchExpand = expanded;

  /* Page de résultats ouverte avec un mot-clé connu (lien direct, favori…) : on applique les synonymes */
  try {
    var p = new URLSearchParams(location.search);
    var q0 = p.get('q');
    if (/\/search\/?$/.test(location.pathname) && q0 && !/\sOR\s/.test(q0) && MAP[norm(q0)] && !p.get('wl_raw')) {
      p.set('q', expanded(q0));
      if (!p.get('options[prefix]')) p.set('options[prefix]', 'last');
      location.replace(location.pathname + '?' + p.toString());
      return;
    }
  } catch (e) {}

  /* Tous les formulaires de recherche du site : réécriture de la requête au moment de l'envoi */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('form[action*="/search"]')) return;
    var input = f.querySelector('input[name="q"]');
    if (!input) return;
    saveRecent(input.value);
    var ex = expanded(input.value.trim());
    if (ex !== input.value.trim()) {
      var h = document.createElement('input');
      h.type = 'hidden'; h.name = 'q'; h.value = ex;
      input.removeAttribute('name');
      f.appendChild(h);
      setTimeout(function () { input.setAttribute('name', 'q'); if (h.parentNode) h.parentNode.removeChild(h); }, 800);
    }
  }, true);
  /* Pastilles « recherches populaires » */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-wl-term]');
    if (!a) return;
    e.preventDefault();
    saveRecent(a.dataset.wlTerm);
    location.href = searchUrl(a.dataset.wlTerm);
  });

  var KEY = 'wl-recent-search';
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function getRecent() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
  function saveRecent(t) {
    t = String(t || '').split(/\sOR\s/)[0].replace(/"/g, '').trim(); if (!t) return;
    var list = getRecent().filter(function (x) { return x.toLowerCase() !== t.toLowerCase(); });
    list.unshift(t); try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, 6))); } catch (e) {}
  }

  var drawer = document.querySelector('.searchbar');
  var input = document.querySelector('[data-searchbar__input]');
  var results = document.querySelector('[data-search-result]');
  var recentBox = document.querySelector('[data-recent-search]');
  if (!drawer || !input || !results) return;
  var timer, ctrls = [], prevFocus, seq = 0;

  function renderRecent() {
    if (!recentBox) return;
    var list = getRecent();
    if (!list.length) { recentBox.innerHTML = ''; return; }
    var html = '<span class="wl-eyebrow" style="margin:8px 0 12px">' + esc(drawer.dataset.wlRecentLabel || 'Recent') + '</span><ul class="wl-chips wl-sr-list">';
    list.forEach(function (t) { html += '<li><a href="' + searchUrl(t) + '">' + esc(t) + '</a></li>'; });
    html += '<li><a href="#" data-wl-clear>' + esc(drawer.dataset.wlClearLabel || 'Clear') + ' ×</a></li></ul>';
    recentBox.innerHTML = html;
  }
  function setState(hasResults) {
    drawer.classList.toggle('wl-has-results', hasResults);
    input.setAttribute('aria-expanded', hasResults ? 'true' : 'false');
    if (recentBox) recentBox.hidden = hasResults;
  }
  function fetchSection(term) {
    var c = window.AbortController ? new AbortController() : null;
    if (c) ctrls.push(c);
    var url = root + 'search/suggest?q=' + encodeURIComponent(term) +
      '&section_id=predictive-search' +
      '&resources[type]=product,collection,query,page,article' +
      '&resources[limit]=8&resources[limit_scope]=each' +
      '&resources[options][unavailable_products]=last' +
      '&resources[options][fields]=title,product_type,variants.title,vendor,tag,body';
    return fetch(url, c ? { signal: c.signal } : {})
      .then(function (r) { return r.text(); })
      .then(function (txt) {
        var doc = new DOMParser().parseFromString(txt, 'text/html');
        return doc.querySelector('#shopify-section-predictive-search');
      })
      .catch(function () { return null; });
  }

  function search(term) {
    term = term.trim();
    ctrls.forEach(function (c) { try { c.abort(); } catch (e) {} });
    ctrls = [];
    var my = ++seq;
    if (term.length < 2) { results.innerHTML = ''; setState(false); drawer.classList.remove('wl-no-results'); return; }
    var list = variants(term).slice(0, 4);
    Promise.all(list.map(fetchSection)).then(function (secs) {
      if (my !== seq) return;
      var base = null;
      secs.forEach(function (s) { if (!base && s && !s.querySelector('[data-wl-none]')) base = s; });
      if (!base) {
        results.innerHTML = secs[0] ? secs[0].innerHTML : '';
        drawer.classList.add('wl-no-results');
        setState(false);
        if (recentBox) recentBox.hidden = true;
        return;
      }
      /* Fusion des produits trouvés via les synonymes (sans doublons, 8 max) */
      var row = base.querySelector('[data-wl-products]');
      if (row) {
        var seen = {};
        row.querySelectorAll('[data-wl-p]').forEach(function (el) { seen[el.dataset.wlP] = 1; });
        secs.forEach(function (s) {
          if (!s || s === base) return;
          s.querySelectorAll('[data-wl-products] [data-wl-p]').forEach(function (el) {
            if (seen[el.dataset.wlP] || row.children.length >= 8) return;
            seen[el.dataset.wlP] = 1;
            row.appendChild(el);
          });
        });
      }
      var all = base.querySelector('[data-wl-all]');
      if (all) all.setAttribute('href', searchUrl(term));
      results.innerHTML = base.innerHTML;
      drawer.classList.remove('wl-no-results');
      setState(true);
      if (window.AOS && typeof AOS.refreshHard === 'function') AOS.refreshHard();
      results.querySelectorAll('[data-aos]').forEach(function (el) { el.classList.add('aos-animate'); });
    });
  }

  function open(trigger) {
    prevFocus = trigger || document.activeElement;
    drawer.classList.add('search-drawer-active');
    document.body.classList.add('no-scroll');
    renderRecent();
    if (typeof window.focusElementsRotation === 'function') window.focusElementsRotation(drawer);
    setTimeout(function () { input.setAttribute('tabindex', '0'); input.focus(); }, 80);
  }
  function close() {
    drawer.classList.remove('search-drawer-active');
    document.body.classList.remove('no-scroll');
    if (typeof window.stopFocusRotation === 'function') window.stopFocusRotation();
    if (prevFocus && prevFocus.focus) prevFocus.focus();
  }

  document.querySelectorAll('[data-search-drawer]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      drawer.classList.contains('search-drawer-active') ? close() : open(btn);
    });
  });
  document.querySelectorAll('[data-search-close]').forEach(function (btn) {
    btn.addEventListener('click', function (e) { e.preventDefault(); close(); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('search-drawer-active')) close();
  });
  input.addEventListener('input', function () {
    clearTimeout(timer);
    var v = input.value;
    timer = setTimeout(function () { search(v); }, 250);
  });
  if (recentBox) recentBox.addEventListener('click', function (e) {
    if (e.target.closest('[data-wl-clear]')) { e.preventDefault(); try { localStorage.removeItem(KEY); } catch (x) {} renderRecent(); }
  });
})();
